import { ItemRarity } from "@/domains/inventory/constants/itemRarity";

const accentColorByRarity: Record<ItemRarity, string> = {
  [ItemRarity.Common]: "#707070",
  [ItemRarity.Rare]: "#94FF28",
  [ItemRarity.Expensive]: "#4377FF",
  [ItemRarity.Magnificent]: "#8753FF",
  [ItemRarity.VIP]: "#FF8450",
};

export default accentColorByRarity;
